export const TemplateEditDialogService = Symbol('TemplateEditDialogService');
